import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  const handleCustomize = () => {
    alert('Η λειτουργία προσαρμογής θα είναι σύντομα διαθέσιμη');
  };

  if (!showConsent) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <h3>Χρησιμοποιούμε Cookies</h3>
          <p>
            Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σας στον ιστότοπό μας, 
            να αναλύσουμε την επισκεψιμότητα και να εξατομικεύσουμε το περιεχόμενο. 
            Τα cookies μας βοηθούν να κατανοήσουμε πώς χρησιμοποιείτε τον ιστότοπό μας 
            και να βελτιώσουμε τις υπηρεσίες μας.
          </p>
          <p>
            Για περισσότερες πληροφορίες, διαβάστε την <Link to="/privacy-policy">Πολιτική Απορρήτου</Link> μας.
          </p>
        </div>
        <div className="cookie-buttons">
          <button onClick={handleAccept} className="cookie-btn accept">
            Αποδοχή Όλων
          </button>
          <button onClick={handleDecline} className="cookie-btn decline">
            Απόρριψη
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;